import ReactDOM from 'react-dom'

import { MySettings } from './apps/MySettings'
import { Popups } from './apps/Popups'
import { isNotMobile, isOnlyVisibleDialog } from './core/pure/Window'
import { isFeatureEnabled, isFeatureNotDisabled } from './core/pure/toggle'
import { prepLocalEnv } from './fixtures'

const renderApp = (): void => {
  const popupDiv = document.getElementById('account-consent-app')

  if (popupDiv && isNotMobile()) {
    setTimeout(() => {
      if (isOnlyVisibleDialog()) {
        ReactDOM.render(<Popups />, popupDiv)
      }
    }, 3000)
  }
}

const renderForTesting = (): void => {
  const popupDiv = document.getElementById('account-consent-app')

  if (popupDiv && isNotMobile()) {
    setTimeout(() => {
      if (isOnlyVisibleDialog()) {
        ReactDOM.render(<Popups />, popupDiv)
      }
    }, 3000)
  }
}

const renderSettings = (): void => {
  const settingsDiv = document.getElementById('account-consent-settings')

  if (settingsDiv) {
    ReactDOM.render(<MySettings />, settingsDiv)
  }
}

if (MH_ENV === 'develop') {
  prepLocalEnv()
  if (isFeatureNotDisabled()) {
    renderApp()
  }
  renderSettings()
} else {
  window.MEDIAHUIS.pubsub?.subscribe('account/getidentity/complete', () => {
    if (isFeatureEnabled() && MH_ENV !== 'production') {
      renderForTesting()
    } else if (isFeatureNotDisabled()) {
      renderApp()
    }
    renderSettings()
  })
}
